<template>
  <div
    class="relative bg-vip-bg bg-fixed bg-cover bg-top bg-[#00284F] py-[80px] px-10 h-[5000px]"
  >
    <!-- Content -->
    <div
      class="relative z-10 flex flex-col items-center text-white text-center py-12 px-4 sm:px-6"
    >
      <!-- Title -->
      <div v-motion-pop-visible class="text-center mb-12">
        <img
          src="@/assets/metaspins-ballyboy-text.png"
          alt="Metaspins x Ballyboy"
          class="mx-auto w-[500px] md:w-[600px]"
        />
      </div>
    </div>

    <!-- Card Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
      <!-- Card 1 -->
      <div
        v-motion-pop-visible
        class="bg-gradient-to-br from-[#1D1D1D] to-[#313B44] rounded-xl shadow-lg p-6"
      >
        <h2 class="flex items-center text-lg font-bold text-yellow-400 mb-2">
          <span class="text-[#EEAF0E] text-3xl align-middle mr-2">●</span>What are VIP Transfers?
        </h2>
        <p class="text-sm text-white/90">
          VIP Transfer is a commonly used term in Online Gambling. It refers to a program
          where players are granted special privileges & bonuses upon becoming a VIP
          player.
        </p>
      </div>

      <!-- Card 2 -->
      <div
        v-motion-pop-visible
        class="bg-gradient-to-br from-[#1D1D1D] to-[#313B44] rounded-xl shadow-lg p-6"
      >
      <h2 class="flex items-center text-lg font-bold text-yellow-400 mb-2">
          <span class="text-[#EEAF0E] text-3xl align-middle mr-2">●</span>How do VIP Transfers Work?
        </h2>
        <p class="text-sm text-white/90">
          Play on MetaSpins and over a 3 week period while enjoying MetaSpins’ great
          rewards system, MetaSpins evaluates players for a potential VIP status based on
          their activity and engagement. <br> <br> If deemed worthy, selected users will receive
          personal contact from a VIP manager, who will provide details about Metaspins
          VIP program and extend an invitation to join.
        </p>
      </div>

      <!-- Card 3 -->
      <div
        v-motion-pop-visible
        class="bg-gradient-to-br from-[#1D1D1D] to-[#313B44] rounded-xl shadow-lg p-6"
      >
      <h2 class="flex items-center text-lg font-bold text-yellow-400 mb-2">
          <span class="text-[#EEAF0E] text-3xl align-middle mr-2">●</span>What are the requirements?
        </h2>
        <ul class="list-disc marker:text-[#EEAF0E] pl-5 text-sm text-white/90 space-y-1">
          <li>
            You MUST have a Metaspins account under code:
            <span class="text-blue-400 underline">BALLYBOY</span>.
          </li>
          <li>
            Not required but it will speed up the process if you have VIP on any other
            gambling website.
          </li>
        </ul>
      </div>

      <!-- Card 4 -->
      <div
        v-motion-pop-visible
        class="bg-gradient-to-br from-[#1D1D1D] to-[#313B44] rounded-xl shadow-lg p-6"
      >
      <h2 class="flex items-center text-lg font-bold text-yellow-400 mb-2">
          <span class="text-[#EEAF0E] text-3xl align-middle mr-2">●</span>Why Choose Metaspins?
        </h2>
        <ul class="list-disc marker:text-[#EEAF0E] pl-5 text-sm text-white/90 space-y-1">
          <li>
            Metaspins provides users with a great and safe experience for all its players.
          </li>
          <li>
            Compete in the Ballyboy Metaspins Leaderboard every month (<span
              class="text-yellow-300 font-bold"
              >$20,000</span
            >).
          </li>
          <li>Great rewards and benefits for players to enjoy short term & long term.</li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
// import axios from 'axios';
// import ConfirmationModal from "@/components/ConfirmationModal.vue";
// import ErrorModal from "@/components/ErrorModal.vue";
// import SuccessModal from "@/components/SuccessModal.vue";
// import ErrorModal from "@/components/ErrorModal.vue";
// import RedirectModal from "@/components/RedirectModal.vue";
// import SuccessModal from "@/components/SuccessModal.vue";
// import TransactionModal from "@/components/TransactionModal.vue";
import axios from "axios";
// import { watch } from 'vue';
// import PrevLeaderboardSection from './PrevLeaderboardSection.vue';

export default {
  data() {
    return {
      loading: false,
      points: 0,
      searchQuery: "",
      showDesktopFilter: false,
      showMobileFilter: false,
      animatedPoints: 0,
      products: [],
      showSortDropdown: false,
      selectedSortOption: "From High to Low",
      sortOptions: [
        { label: "From Hight to Low", value: "highToLow" },
        { label: "From Low to High", value: "lowToHigh" },
        { label: "From A to Z", value: "aToZ" },
        { label: "From Z to A", value: "zToA" },
      ],
      // categories: ["All", "Tips", "Bonus"],
      // selectedCategory: "All",
      selectedPointsRange: "",
      minPoints: "",
      maxPoints: "",
      currentPage: 1,
      itemsPerPage: 8,
      showErrorModal: false,
      errorMessage: "",
      showSuccessModal: false,
      showConfirmModal: false,
      showRedirectModal: false,
      hasDiscord: false,
      selectedProductId: null,
      selectedProductName: "",
      selectedProductPoints: 0,
      showTransactionModal: false,
      animatedTotalItems: 0,
      transactions: [],
    };
  },
  watch: {
    selectedSortOption(newVal) {
      this.selectedSortLabel = newVal;
    },
    totalItems(newValue) {
      this.animateNumber("animatedTotalItems", newValue);
    },
  },
  // components: {
  //   SuccessModal,
  //   ErrorModal,
  //   ConfirmationModal,
  //   RedirectModal,
  //   TransactionModal,
  // },
  computed: {
    filteredProducts() {
      let filtered = this.products.filter((product) => product.status === "active");

      if (this.searchQuery) {
        filtered = filtered.filter((product) =>
          product.title.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }

      if (this.selectedCategory && this.selectedCategory.toLowerCase() !== "all") {
        filtered = filtered.filter(
          (product) =>
            product.category.toLowerCase() === this.selectedCategory.toLowerCase()
        );
      }

      if (this.minPoints !== "" || this.maxPoints !== "") {
        const min = this.minPoints !== "" ? Number(this.minPoints) : 0;
        const max = this.maxPoints !== "" ? Number(this.maxPoints) : Infinity;

        filtered = filtered.filter(
          (product) => product.requiredPoints >= min && product.requiredPoints <= max
        );
      }

      return filtered;
    },

    selectedSortLabel() {
      return this.selectedSortOption;
    },

    paginatedProducts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredProducts.slice(start, start + this.itemsPerPage);
    },
    totalItems() {
      return this.filteredProducts.length;
    },
    totalPages() {
      return Math.ceil(this.filteredProducts.length / this.itemsPerPage);
    },
    itemStart() {
      return this.totalItems === 0 ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1;
    },
    itemEnd() {
      return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
    },
    visiblePages() {
      const range = [];
      let start = Math.max(1, this.currentPage - 2);
      let end = Math.min(this.totalPages, this.currentPage + 2);

      for (let i = start; i <= end; i++) {
        range.push(i);
      }
      return range;
    },
  },
  methods: {
    async init() {
      const baseUrl = process.env.VUE_APP_BASE_API;
      this.loading = true;

      try {
        // Fetch user data
        const token = localStorage.getItem("accessToken");

        if (token) {
          const userResponse = await axios.get(`${baseUrl}/api/users/me`, {
            headers: {
              "x-api-key": process.env.VUE_APP_X_API_KEY,
              Authorization: `Bearer ${token}`,
            },
          });

          if (userResponse.data) {
            this.hasDiscord = userResponse.data.user.discordId;

            this.showRedirectModal = !this.hasDiscord;
          }

          this.animateValues();
        }
      } catch (error) {
        console.error("Error loading data", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchProducts() {
      this.loading = true;
      const baseUrl = process.env.VUE_APP_BASE_API;

      try {
        const response = await axios.get(`${baseUrl}/api/store/products`, {
          headers: {
            "x-api-key": process.env.VUE_APP_X_API_KEY,
          },
        });

        this.products = response.data.products || [];
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        this.loading = false;
      }
    },
    async purchaseProduct(productId) {
      const baseUrl = process.env.VUE_APP_BASE_API;
      const token = localStorage.getItem("accessToken");

      if (!token) {
        this.showError("You must be logged in to make a purchase.");
        return;
      }

      try {
        const response = await axios.post(
          `${baseUrl}/api/store/purchase`,
          { productId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "x-api-key": process.env.VUE_APP_X_API_KEY,
            },
          }
        );

        if (response.status === 200) {
          this.showSuccess(response.data.ticket);
          this.fetchProducts();
          this.init();
        }
      } catch (error) {
        if (error.response) {
          const { status, data } = error.response;
          if (status === 402) {
            this.showError("⚠️ Insufficient points to purchase this product.");
          } else if (status === 422) {
            this.showError("⚠️ Invalid input: Product ID is required.");
          } else {
            this.showError(`❌ Error: ${data.message}`);
          }
        } else {
          this.showError("❌ Failed to process purchase. Please try again.");
        }
      }
    },
    async fetchUserPoints() {
      const baseUrl = process.env.VUE_APP_BASE_API;
      const token = localStorage.getItem("accessToken");

      if (!token) {
        console.error("User not authenticated.");
        return;
      }

      try {
        const response = await axios.get(`${baseUrl}/api/users/me/points`, {
          headers: {
            "x-api-key": process.env.VUE_APP_X_API_KEY,
            Authorization: `Bearer ${token}`,
          },
        });

        this.points = response.data.points;

        this.animateValues();
      } catch (error) {
        console.error("Error fetching user points:", error);
      }
    },
    async fetchTransactions() {
      const baseUrl = process.env.VUE_APP_BASE_API;
      const token = localStorage.getItem("accessToken");

      if (!token) {
        console.error("User not authenticated.");
        return;
      }

      try {
        const response = await axios.get(`${baseUrl}/api/store/purchase/transactions`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.VUE_APP_X_API_KEY,
          },
        });

        if (response.status === 200) {
          this.transactions = response.data.purchaseTransactions
            ? response.data.purchaseTransactions.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
              )
            : [];
          this.showTransactionModal = true;
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    },
    async confirmPurchase() {
      if (!this.selectedProductId) {
        this.showError("❌ No product selected.");
        return;
      }

      this.loading = true;
      try {
        await this.purchaseProduct(this.selectedProductId);
        this.showConfirmModal = false;
      } catch (error) {
        console.error("Purchase failed:", error);
      } finally {
        this.loading = false;
      }
    },
    showSuccess(ticket) {
      this.ticket = ticket;
      this.showSuccessModal = true;
    },
    showError(message) {
      console.log("Error Triggered:", message);
      this.errorMessage = message;
      this.showErrorModal = true;
    },
    showConfirm(product) {
      if (!this.hasDiscord) return;

      this.selectedProductId = product._id;
      this.selectedProductName = product.title;
      this.selectedProductPoints = product.requiredPoints;
      this.showConfirmModal = true;
    },
    animateValues() {
      this.animateNumber("animatedPoints", this.points);
    },
    animateNumber(variable, targetValue) {
      let startValue = this[variable] || 0;
      if (startValue === targetValue) return;

      const step = Math.max(1, Math.abs(targetValue - startValue) / 20); // Ensures step is at least 1
      const isNegative = startValue > targetValue;

      const interval = setInterval(() => {
        if (isNegative) {
          startValue -= step;
          if (startValue <= targetValue) {
            startValue = targetValue;
            clearInterval(interval);
          }
        } else {
          startValue += step;
          if (startValue >= targetValue) {
            startValue = targetValue;
            clearInterval(interval);
          }
        }

        // Ensure whole numbers with commas
        this[variable] = Math.round(startValue).toLocaleString();
      }, 50);
    },
    toggleDesktopFilter() {
      this.showDesktopFilter = !this.showDesktopFilter;
      console.log("desktop dropdown working");
    },
    toggleMobileFilter() {
      this.showMobileFilter = !this.showMobileFilter;
      console.log("mobile dropdown working");
    },
    applyFilter() {
      this.currentPage = 1;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    toggleSortDropdown() {
      this.showSortDropdown = !this.showSortDropdown;
    },
    applySort(option) {
      this.selectedSortOption = option.label;
      this.sortProducts(option.value);
      this.showSortDropdown = false; // Close dropdown after selection
    },
    sortProducts(order) {
      if (order === "highToLow") {
        this.products.sort((a, b) => b.requiredPoints - a.requiredPoints);
      } else if (order === "lowToHigh") {
        this.products.sort((a, b) => a.requiredPoints - b.requiredPoints);
      } else if (order === "aToZ") {
        this.products.sort((a, b) => a.title.localeCompare(b.title));
      } else if (order === "zToA") {
        this.products.sort((a, b) => b.title.localeCompare(a.title));
      }
    },
  },
  mounted() {
    this.init();
    this.fetchProducts();
    this.fetchUserPoints();
  },
};
</script>
